// Copyright (c) Secured2
// Licensed.

/**
 *  Calls helper functions.
 */

import {
  NOTIF_INFO,
  NOTIF_FAIL,
  NOTIF_DEFAULT,
  NOTIF_SUCCESS,
  STND_SUC_MESSAGE,
  NOTIF_WARN,
  STND_ERR_MESSAGE,
  STND_ERR_SYSMESSAGE,
} from "./globalconstants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";

// Define an array of key-value pairs
let GLOBALITEMS: KeyValuePair[] = [];
// turn on debugging 0 is off 1 is on
const GDEBUG: string = "0";

// Helper methods for getting Global consts.
export function getGlobalconst(key: string) {
  const pair = GLOBALITEMS.find((item) => item.key === key);
  return pair ? pair.value : undefined;
}

// Helper methods for setting Global consts.
export async function setGlobalconst(key: string, value: string): Promise<number> {
  return new Promise((resolve, reject) => {
    try {
      const foundpair: any = GLOBALITEMS.find((item) => item.key === key);
      if (foundpair != undefined) {
        GLOBALITEMS.splice(
          GLOBALITEMS.findIndex((item) => item.key === key),
          1
        );
      }
      // now add back in..
      const pair = { key: key, value: value };
      GLOBALITEMS.push(pair);
      resolve(0);
    } catch (error) {
      reject(new Error("Function setGlobalconst failed" + error));
    }
  });
}

// Helper methods for setting Global vars.
export function appendGlobalconst(key: string, value: string, startdelimiter: string, enddelimiter: string) {
  const resultvalue = getGlobalconst(key);
  setGlobalconst(key, resultvalue + startdelimiter + value + enddelimiter);
}

// types of notifications
//const NOTIF_FAIL: string = "error";
//const NOTIF_SUCCESS: string = "success";
//const NOTIF_INFO: string = "info";
//const NOTIF_WARN: string = "warning";
//const NOTIF_DEFAULT: string = "default";
export function showNotification(displaytype: string, textToDisplay: string): void {
  if (displaytype == null) {
    displaytype = NOTIF_DEFAULT;
  }
  if (displaytype == NOTIF_FAIL || displaytype == NOTIF_WARN) {
    showErrorToast(textToDisplay);
  } else {
    showSuccessToast(textToDisplay);
  }
}

export function formatStandardUserErrorMessage(functionName: string, textToAdd: string): void {
  let formatedMsg: string = STND_ERR_MESSAGE.replace("<MSG>", textToAdd);
  return formatedMsg.replace("<ACTION>", functionName);
}

export function formatStandardSystemErrorMessage(functionName: string, textToAdd: string, error: any): void {
  let formatedMsg: string = STND_ERR_SYSMESSAGE.replaceAll("<MSG>", textToAdd);
  formatedMsg = formatedMsg.replace("<ERROR>", error);
  return formatedMsg.replace("<FUNC>", functionName);
}

export function formatStandardUserSuccessMessage(functionName: string, textToAdd: string, error: any): void {
  let formatedMsg: string = STND_SUC_MESSAGE.replaceAll("<MSG>", textToAdd);
  formatedMsg = formatedMsg.replace("<ERROR>", error);
  return formatedMsg.replace("<FUNC>", functionName);
}

export function dumpdebug(title: string, details: string) {
  if (GDEBUG == "1") {
    showNotification(NOTIF_INFO, "DEBUG On - " + title + "Details - " + details);
  }
}

export function convertToDateAndFormat(dateString: string, formatsytle: string): string {
  let date = new Date();
  if (dateString != "NOW") {
    date = new Date(dateString);
  }

  // Ensure the date is valid
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string");
  }

  const formatted: string = format(date, formatsytle); // formats into the specified value

  /*
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  //const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year
  const year = String(date.getFullYear());
  const hour = String(date.getHours());
  const min = String(date.getMinutes);
  const sec = String(date.getSeconds);
  const ms = String(date.getMilliseconds);

  formatsytle.replace("MM", month);
  formatsytle.replace("${year}", year);
  formatsytle.replace("${day}", day);
  formatsytle.replace("${hour}", hour);
  formatsytle.replace("${min}", min);
  formatsytle.replace("${sec}", sec);
  formatsytle.replace("${ms}", ms);

  return formatsytle;
  */

  return formatted;
}

export function formatEmails(emailList: { [displayName: string]: string }) {
  let fullList: String = "";
  for (const displayName in emailList) {
    if (validateEmail(emailList[displayName])) {
      // This check ensures the property is not from the prototype chain
      fullList += ":<" + displayName + "><" + emailList[displayName] + ">~";
      fullList += ";";
    }
  }
  return fullList;
}

export function validateEmail(email: string) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function encodeToWindows1252(input: string): Uint8Array {
  const encoder = new TextEncoder(); // Create a TextEncoder instance
  const encoded = encoder.encode(input); // Encode the input string
  const windows1252Bytes = new Uint8Array(encoded.length);
  for (let i = 0; i < encoded.length; i++) {
    windows1252Bytes[i] = encoded[i]; // Map each character to Windows-1252
  }
  return windows1252Bytes;
}

// --- Helper Functions ---
export function formatBytes(bytes: number, decimals = 2): string {
  if (!+bytes) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function decodeToWindows1252(input: Uint8Array): string {
  return new TextDecoder("utf-8").decode(input);
}

const showSuccessToast = (message: string) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

const showErrorToast = (message: string) => {
  toast.error(message || "Error!", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
